import { useDispatch } from 'react-redux';
import { modalsToggle } from 'actions';
import { ADMIN_VEHICLE_STATUS, AUCTION_STATUSES } from 'constants';
import { SendOfferModal } from 'components/Offers';
import { Vehicle } from 'types/vehicle';
import { auctionOfferStatuses } from 'utils/statusCalculator';
import { useNoSelectorVehicleOfferAuctionById } from 'hooks';
import { useCurrentUser } from 'hooks/selectors';
import moment from 'moment';
import { ActionRow } from '../ActionRow';

type Props = {
  vehicle: Vehicle;
};

export const CounterHighestBid = ({ vehicle }: Props) => {
  const offerAuction = useNoSelectorVehicleOfferAuctionById(vehicle.id);

  const dispatch = useDispatch();
  const openCounterModal = () => dispatch(modalsToggle(`sendVehicleOffer-${vehicle.id}`));

  const user = useCurrentUser();
  const isVehicleTimerEnded = vehicle.date_end && moment.utc(vehicle.date_end).isBefore(moment.utc());
  const status = auctionOfferStatuses(vehicle, offerAuction, user);
  const isAuctionActive = vehicle.auction && vehicle.auction.status !== AUCTION_STATUSES.ENDED;
  const isBotWinner = vehicle.highest_bid?.bidder?.is_bot;

  const renderSection =
    isVehicleTimerEnded && isAuctionActive && status !== ADMIN_VEHICLE_STATUS.BUYER_COUNTER_SENT && !isBotWinner;

  console.log(renderSection, 'renderSection');

  if (!renderSection) return null;

  return (
    <>
      <ActionRow label="Counter the Highest Bid" buttonConfig={{ handleClick: openCounterModal, label: 'Counter' }} />
      <SendOfferModal maxAmount={vehicle.reserve_price} form={`sendVehicleOffer-${vehicle.id}`} vehicle={vehicle} />
    </>
  );
};
